const INFO = {
	main: {
		title: "Aryan vashisht - portfolio",
		name: "Aryan Vashisht",
		email: "vashishtaryan13@gmail.com",
		logo: "../movinglogoman.jpg",
	},

	socials: {
		twitter: "https://x.com/aryanvashisht_",
		github: "https://github.com/aryanvashisht",
		linkedin: "https://linkedin.com/in/aryanvashisht1",
		// instagram: "https://instagram.com/",
		// stackoverflow: "https://stackoverflow.com/",
		// facebook: "https://facebook.com/",
	},

	homepage: {
		title: "Full-Stack MERN Developer",
		description:
			"I build practical, real-world products using the MERN stack — from e-commerce with payments to AI-powered tools and media platforms. Clean architecture, scalable APIs, and fast UI — that's my focus. Always improving. Always shipping.",
	},
	about: {
		title: "I’m Aryan Vashisht — a Full-Stack Developer building practical products.",
		description:
			"I build full-stack applications using the MERN stack, focusing on clean architecture, scalable APIs, and fast user experiences. My projects include a production-style e-commerce system with payments, an AI-powered code review tool, and a YouTube-like backend with media handling. I ship real products, write maintainable code, and constantly push myself to learn by building — not just watching tutorials."
	},
	articles: {
		title: "I document what I build — not theory or fluff.",
		description:
			"I write breakdowns on MERN stack projects, architecture decisions, performance fixes, and real deployment lessons. No motivational quotes, no generic tutorials — just practical, battle-tested stuff from actually building things."
	},
	projects: [
		{
			title: "UrbanBasket — E-Commerce Platform",
			description:
				"Full-stack e-commerce app with JWT authentication, admin dashboard, product management, and Razorpay payments. Built with clean API architecture and secure user workflows.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Repository",
			linkText2: "Live link",
			techStackUsed: {
				techstack: [
					"React",
					"Node.js",
					"Express.js",
					"MongoDB",
					"JWT",
					"Razorpay",
					"TailwindCSS"
				],
				others: [
					"REST API",
					"Cloudinary",
					"Postman",
					"Git & GitHub"
				]
			},
			link: "",
			livelink: "",
		},

		{
			title: "CodeSense AI — AI Code Reviewer",
			description:
				"AI-powered platform that analyzes developer code and returns structured, syntax-highlighted feedback. Integrated Gemini API with secure Node backend and React 19 UI.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Repository",
			linkText2: "Live link",
			techStackUsed: {
				techstack: [
					"React.js (v19)",
					"Node.js",
					"Express.js",
					"Gemini API",
					"TailwindCSS",
					"PrismJS Syntax Highlighter"
				],
				others: [
					"Gemini API (@google/genai)",
					"Vite",
					"Axios",
					"React Markdown",
					"PrismJS",
					"REST APIs",
				]
			},
			link: "",
			livelink: "",
		},

		{
			title: "WeTube API — Video Platform Backend",
			description:
				"Backend for a YouTube-style app with user channels, subscriptions, secure JWT auth, Cloudinary media storage, and advanced MongoDB aggregation pipelines.",
			logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/javascript/javascript.png",
			linkText: "View Repository",
			linkText2: "Live link",
			techStackUsed: {
				techstack: [
					"Node.js",
					"Express.js",
					"MongoDB",
					"Mongoose",
				],
				others: [
					"JWT (Access/Refresh Tokens)",
					"Cloudinary",
					"Multer",
					"REST APIs",
					"Aggregation Pipelines",
					"Postman",
					"Git & GitHub",
					"render"
				]
			},
			link: "https://github.com/aryanvashisht/wetube-server",
			livelink: "https://wetube-server.onrender.com/new",
		},

		// {
		// 	title: "Crew AI Automation Workflow",
		// 	description:
		// 		"Built automated workflows using CrewAI and custom agents to streamline document processing and task execution, showcasing applied AI + automation skills.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/python/python.png",
		// 	linkText: "View Repository",
		// 	techStackUsed: {
		// 		techstack: [
		// 			"Python",
		// 			"CrewAI",
		// 			"LangChain Agents"
		// 		],
		// 		others: [
		// 			"API Integrations",
		// 			"Automation Pipelines",
		// 			"Git & GitHub"
		// 		]
		// 	},
		// 	link: "YOUR_REPO_OR_CASE_STUDY_LINK",
		// },
		// {
		// 	title: "Document Understanding with UiPath",
		// 	description:
		// 		"Implemented intelligent document processing pipelines with UiPath Document Understanding, ML extraction models, and validation workflows.",
		// 	logo: "https://cdn.jsdelivr.net/npm/programming-languages-logos/src/other/other.png",
		// 	linkText: "View Case Study",
		// 	techStackUsed: {
		// 		techstack: [
		// 			"UiPath",
		// 			"Document Understanding",
		// 			"ML Extractor",
		// 			"OCR Engines (Tesseract / Microsoft / Abbyy)"
		// 		],
		// 		others: [
		// 			"Automation Workflows",
		// 			"Validation Station",
		// 			"Business Use-Cases",
		// 			"Version Control"
		// 		]
		// 	},
		// 	link: "YOUR_PORTFOLIO_OR_DRIVE_LINK",
		// }
	],
};

export default INFO;
